<div class="sg-input-container">
  <label class="sg-input-label" *ngIf="label">{{ label }}</label>
  <p class="sg-input-description" *ngIf="description">{{ description }}</p>

  <div class="sg-input-wrapper" [class.has-icon]="withIcon">
    @if (withIcon) {
      <ptl-icon class="sg-input-icon" [icon]="icon" size="xs"></ptl-icon>
    }

    <input
      *ngIf="matAutocomplete"
      #inputElement
      class="sg-input-field"
      [class.sg-input-field--invalid]="invalid"
      [attr.aria-label]="ariaLabel || label"
      [class.size-s]="size === 's'"
      [type]="type"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [value]="value"
      [attr.maxlength]="maxLength"
      [attr.min]="min"
      [attr.max]="max"
      [matAutocomplete]="matAutocomplete"
      (input)="onInputChange($event)"
      (blur)="onBlur()"
      (focus)="onFocus()"
    />
    <input
      *ngIf="!matAutocomplete"
      #inputElement
      class="sg-input-field"
      [class.sg-input-field--invalid]="invalid"
      [attr.aria-label]="ariaLabel || label"
      [class.size-s]="size === 's'"
      [type]="type"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [value]="value"
      [attr.maxlength]="maxLength"
      [attr.min]="min"
      [attr.max]="max"
      (input)="onInputChange($event)"
      (blur)="onBlur()"
      (focus)="onFocus()"
    />

    @if (clearable && value && !disabled) {
      <button
        type="button"
        class="sg-input-clear"
        [attr.aria-label]="clearAriaLabel ?? ('translations.global.ariaLabels.clearSearchResult' | transloco)"
        (click)="clear()"
      >
        <span aria-hidden="true">×</span>
      </button>
    }
  </div>
</div>
